import axios from 'axios'
import { BASE_URL } from 'config/env'
import {
  camelizeResponseInterceptor,
  decamelizeRequestInterceptor,
  setAuthHeaders,
} from 'repositories/utils/interceptors'

export const berthApiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

berthApiClient.interceptors.request.use((config) => {
  setAuthHeaders(config)
  return decamelizeRequestInterceptor(config)
})

berthApiClient.interceptors.response.use(camelizeResponseInterceptor)

export const fetcher = <T = unknown>(url: string): Promise<T> =>
  berthApiClient.get<T>(url).then((res) => res.data)
